import React from "react";
import "../post.css";
import DayFour from "../images/day_four.jpeg";

export default class Post extends React.Component {
  render() {
    return (
      <div className="card">
        <h2 className="header">Day Four</h2>
        <img className="image" alt="itinerary" src={DayFour} />
        <div className="infobar">
          <div className="info">23 Nov 2018</div>
        </div>
        <h3>Morning</h3>
        <p>
          Last day in Tokyo. Head to Shinjuku station in the morning for
          breakfast. Catch the morning bus to Kawaguchiko. The ride is about 3
          hours long.
        </p>
        <h3>Afternoon</h3>
        <p>
          Kawaguchiko. Arrive in the afternoon at Kawaguchiko station. Koe's
          House is a 5 minute walk away. The rooms are small with common
          bathrooms, but it's the most convenient place to bunk in for a night,
          not two.
        </p>
        <h3>Evening</h3>
        <p>
          Walk down to Lake Kawaguchiko for a night view of the town. Shops
          close early. Tempura Restaurant Ninjya's great for dinner.
        </p>
      </div>
    );
  }
}
